<template>
  <!-- ケアオーケストレーター　ディーラーメニュー -->
  <div id="CODealerMenu">
    <div id="container-center">
      <div class="title is-3">ケア オーケストレーター　メニュー</div>
      <div class="cogrid-area">
        <div class="grid-container">
          <ul class="tile-container">
            <li>
              <div class="contents">
                <router-link :to="{name:'CORegistRequest', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-hospital-building mdi-48px"  style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">施設追加</div>
                </router-link>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link :to="{name:'CODealerHospitalSearch', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-file-document-multiple-outline mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">各種申請</div>
                </router-link>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link :to="{name:'CODealerRequestList', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-format-list-bulleted mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">申請一覧</div>
                </router-link>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link to="/guest/home">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-keyboard-return mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">サービス一覧に戻る</div>
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CODealerMenu",
  methods: {},
  data() {
    return {};
  },
  components: {}
};
</script>

<style lang="scss" >
.grid-container {
    height:500px;
}
.cogrid-area {
  display: grid;
  width: 700px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/CODealerMenu.vue